import { YahooTracker } from '@buzzfeed/third-party-analytics';
import { CLUSTER } from '../../../constants';

export async function trackYahooPageview() {
  new YahooTracker({ client: 'bpage', cluster: CLUSTER });
}
